import { Seo, breadcrumbSchema } from "@/components/layout/Seo";
import { PageHero } from "@/components/ui/motion";
import { TeamGrid } from "@/components/sections/TeamGrid";

export default function Consultants() {
  const crumbs = [{ to: "/", label: "Beranda" }, { to: "/konsultan", label: "Konsultan" }];
  return (
    <>
      <Seo title="Tim Konsultan | Mika Solution" description="Kenali tim konsultan Mika Solution dan hubungi langsung melalui WhatsApp untuk konsultasi kewajiban Pinjol, kartu kredit, dan KTA." path="/konsultan" schema={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Tim Konsultan" lines={["Pilih Konsultan,", <span className="serif-it font-normal text-accentb">Mulai Bercerita.</span>]} desc="Setiap konsultan siap mendengarkan kondisi Anda secara rahasia. Pilih salah satu untuk melihat profil dan menghubunginya langsung via WhatsApp." />
      <section className="py-16 sm:py-24" data-testid="consultants-page">
        <div className="wrap"><TeamGrid filter /></div>
      </section>
    </>
  );
}
